export default __webpack_public_path__ + "static/business-img-c4638795ac4d82dbb8e4d23d46f87a0a.png";